import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  setActiveTest
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import s from './Tests.css';

class Tests extends PureComponent {

  selectTest(name) {
    this.props.setActiveTest(name);
  }

  checkIfCompleted(name) {
    const completed = this.props.testData.results.filter((result) => result.name === name);
    return completed.length > 0 ? true : false;
  }

  render() {
    // const {
    //   testData
    // } = this.props;
    // override what test to show
    const testData = {tests:[LA_TEST,LF_TEST]};

    const nfCompleted = this.checkIfCompleted(NF_TEST);
    const rrCompleted = this.checkIfCompleted(RR_TEST);
    const laCompleted = this.checkIfCompleted(LA_TEST);
    const bsCompleted = this.checkIfCompleted(BS_TEST);
    const lfCompleted = this.checkIfCompleted(LF_TEST);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {/* <div className={s.headerRow}></div> */}
            <div className={s.headerTitle}>Please choose from the Tools below</div>
          </div>
        </div>
        <div className="row">
          { testData.tests.includes(NF_TEST) &&
            <div className="col-lg-4 col-md-12">
              <div className={s.testContainer}>
              <div className={s.testTitle}>Big Picture Assessment</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  This test will take a couple of minutes to complete. It is designed to reveal
                  important aspects of your financial decision-making style.
                </div>
                { nfCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(NF_TEST)}>RETAKE</button>
                }
                { !nfCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(NF_TEST)}>START</button>
                }
              </div>
              </div>
            </div>
          }
          { testData.tests.includes(LA_TEST) &&
            <div className="col-md-4 col-sm-12">
              <div className={s.testContainer}>
                <div className={s.testTitle}>Loss Aversion</div>
                <div className={s.testBody}>
                  <div className={s.testCopy}>
                    On each of the following 10 pages, you will see a pair of gambles.
                    Each gamble has three equally likely outcomes.
                    <br /><br />
                    For each page, please choose which gamble you prefer.
                  </div>
                  { laCompleted &&
                    <button className={s.retakeButton} onClick={() => this.selectTest(LA_TEST)}>RETAKE</button>
                  }
                  { !laCompleted &&
                    <button className={s.testButton} onClick={() => this.selectTest(LA_TEST)}>START</button>
                  }
                </div>
              </div>
            </div>
          }
          { testData.tests.includes(BS_TEST) &&
            <div className="col-lg-4 col-md-12">
            <div className={s.testContainer}>
              <div className={s.testTitle}>Behavioral Stress</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  One of the keys to a successful retirement is making sure you set the right financial goals.
                  The following assessment tool, which takes just a few minutes to complete, can help ensure
                  that your goals reflect your future retirement needs.
                  <br /><br />
                  The survey consists of four questions and takes a couple of minutes to complete.
                </div>
                <div style={{width:'100%',textAlign:'center'}}>
                { bsCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(BS_TEST)}>RETAKE</button>
                }
                { !bsCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(BS_TEST)}>START</button>
                }
                </div>
              </div>
              </div>
            </div>
          }
          { testData.tests.includes(RR_TEST) &&
            <div className="col-lg-4 col-md-12">
            <div className={s.testContainer}>
              <div className={s.testTitle}>Present Bias</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                  This survey can help you determine whether you are likely to regret the
                  timing of your retirement. In particular, it can identify whether you
                  are at risk of retiring too early, a financial mistake with serious consequences.
                  <br /><br />
                  The survey consists of six questions and takes a couple of minutes to complete.
                </div>
                <div style={{width:'100%',textAlign:'center'}}>
                { rrCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(RR_TEST)}>RETAKE</button>
                }
                { !rrCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(RR_TEST)}>START</button>
                }
                </div>
              </div>
            </div>
            </div>
          }
          { testData.tests.includes(LF_TEST) &&
            <div className="col-md-4 col-sm-12">
            <div className={s.testContainer}>
              <div className={s.testTitle}>Mental Accounting of Losses</div>
              <div className={s.testBody}>
                <div className={s.testCopy}>
                This tool can help you assess how sensitive you feel the ups and
                downs of the market.
                  <br /><br />
                  The survey consists of six questions and takes a couple of minutes to complete.
                </div>
                <div style={{width:'100%',textAlign:'center'}}>
                { lfCompleted &&
                  <button className={s.retakeButton} onClick={() => this.selectTest(LF_TEST)}>RETAKE</button>
                }
                { !lfCompleted &&
                  <button className={s.testButton} onClick={() => this.selectTest(LF_TEST)}>START</button>
                }
                </div>
              </div>
            </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
  };
}

export default connect(mapStateToProps,{
  setActiveTest,
})(Tests);



// WEBPACK FOOTER //
// ./src/components/ClientMode/Tests.js